import { render, staticRenderFns } from "./LevelFormulaForm.vue?vue&type=template&id=596603da&scoped=true&"
import script from "./LevelFormulaForm.vue?vue&type=script&lang=js&"
export * from "./LevelFormulaForm.vue?vue&type=script&lang=js&"
import style0 from "./LevelFormulaForm.vue?vue&type=style&index=0&id=596603da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596603da",
  null
  
)

export default component.exports